import { useQuery } from "@tanstack/vue-query";
import hostInstitutionService from "@/services/hostInstitution.js";

export const useGetHostInstitutionsData = (limit, page, q) => {
  return useQuery({
    queryKey: ["fetchHostInstitutionsData", limit, page, q],
    queryFn: () =>
      hostInstitutionService
        .getHostInstitutions({
          limit: limit,
          page: page,
          q: q.value ?? "",
        })
        .then((val) => val?.data?.data?.items),
    staleTime: 0,
  });
};
